export default "__VITE_ASSET__284ff878__"